const shader = `
  varying vec2 vTextureCoord;
  uniform sampler2D uSampler;

  uniform vec4 filterArea;
  uniform vec4 filterClamp;
  uniform vec2 dimensions;
  uniform int direction;

  uniform bool mirrorLeftToRight;
  uniform bool mirrorRightToLeft;
  uniform bool mirrorTopToBottom;
  uniform bool mirrorBottomToTop;

  uniform float boundary;

  void applyLeftToRightMirror() {
      vec2 pixelCoord = vTextureCoord.xy * filterArea.xy;
      vec2 coord = pixelCoord / dimensions;

      if (coord.x < boundary) {
          gl_FragColor = texture2D(uSampler, vTextureCoord);
          return;
      }

      float areaX = boundary * dimensions.x / filterArea.x;
      float mirroredX = areaX + areaX - vTextureCoord.x;
      vec4 color = texture2D(uSampler, vec2(mirroredX, vTextureCoord.y));
      gl_FragColor = color;
  }

  void applyRightToLeftMirror() {
      vec2 pixelCoord = vTextureCoord.xy * filterArea.xy;
      vec2 coord = pixelCoord / dimensions;

      if (coord.x > (1.0 - boundary)) {
          gl_FragColor = texture2D(uSampler, vTextureCoord);
          return;
      }

      float areaX = (1.0 - boundary) * dimensions.x / filterArea.x;
      float mirroredX = areaX + areaX - vTextureCoord.x;
      vec4 color = texture2D(uSampler, vec2(mirroredX, vTextureCoord.y));
      gl_FragColor = color;
  }

  void applyTopToBottomMirror() {
      vec2 pixelCoord = vTextureCoord.xy * filterArea.xy;
      vec2 coord = pixelCoord / dimensions;

      if (coord.y < boundary) {
          gl_FragColor = texture2D(uSampler, vTextureCoord);
          return;
      }

      float areaY = boundary * dimensions.y / filterArea.y;
      float mirroredY = areaY + areaY - vTextureCoord.y;
      vec4 color = texture2D(uSampler, vec2(vTextureCoord.x, mirroredY));
      gl_FragColor = color;
  }

  void applyBottomToTopMirror() {
      vec2 pixelCoord = vTextureCoord.xy * filterArea.xy;
      vec2 coord = pixelCoord / dimensions;

      if (coord.y > (1.0 - boundary)) {
          gl_FragColor = texture2D(uSampler, vTextureCoord);
          return;
      }

      float areaY = (1.0 - boundary) * dimensions.y / filterArea.y;
      float mirroredY = areaY + areaY - vTextureCoord.y;
      vec4 color = texture2D(uSampler, vec2(vTextureCoord.x, mirroredY));
      gl_FragColor = color;
  }

  void main(void) {
    int fromTopToBottom = 0;
    int fromLeftToRight = 1;
    int fromBottomToTop = 2;
    int fromRightToLeft = 3;

    if (direction == fromLeftToRight) {
        applyLeftToRightMirror();
    } else if (direction == fromRightToLeft) {
        applyRightToLeftMirror();
    } else if (direction == fromTopToBottom) {
        applyTopToBottomMirror();
    } else if (direction == fromBottomToTop) {
        applyBottomToTopMirror();
    } else {
        gl_FragColor = texture2D(uSampler, vTextureCoord);
    }
  }
`;

exports.shader = shader;
